import { render, staticRenderFns } from "./ExecutiveSummaryCollections.vue?vue&type=template&id=20646add&scoped=true"
import script from "./ExecutiveSummaryCollections.vue?vue&type=script&lang=js"
export * from "./ExecutiveSummaryCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20646add",
  null
  
)

export default component.exports